import { XemploStateScope } from '@xemplo/types';

const baseEndpoint = 'api/v2/state';

/**
 * API endpoints for Xemplo state management.
 *
 * These endpoints handle the retrieval and modification of application state
 * across different scopes (All, Session, User, Persona).
 *
 * For the remote state management, the API follows RESTful conventions
 * and expose the same base endpoint for all REST verbs.
 * Hence, we can simplify the implementation instead of the usual
 * approach which prefixes the verb into the endpoint name.
 */
export const XemploStateEndpoint = {
  /** Endpoint for operations that require a specific scope */
  create: (scope?: XemploStateScope) =>
    scope ? `${baseEndpoint}/${scope}` : baseEndpoint,
} as const;

/**
 * Query keys used for React Query cache management.
 *
 * These keys are used to identify and invalidate cached query data.
 */
export const XemploStateQueryKeys = {
  /** Base query key for all state-related queries */
  getState: 'getState',
};
